import BaseModel from '../core/BaseModel'
export default class AppraisalProductHistoryModel extends BaseModel {
    constructor() {
        super({ 
                name: "appraisal_product_history",
                tableName: 'core_appraisal_product_history'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                class: 'top-datepicker',
                sortable: true,
                width: 15,
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                class: 'center',
                computed: (data) => {
                    data.full_name = (data.users != undefined && data.users != null) ? data.users.full_name : '';
                }
            },
            organization_name: { 
                name: 'organization_name', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                computed: (data) => {
                    var organization = (data.users != undefined && data.users != null && data.users.organization_account != undefined && data.users.organization_account != null) ? data.users.organization_account : null;
                    if (organization != null) {
                        data.organization_name = (organization.organization != undefined && organization.organization != null ) ? organization.organization.name : '';
                    }
                }
            },
            note: { 
                name: 'note', 
                label: 'Nội dung'
            },
            status: { 
                name: 'status', 
                type: "Selection",
                label: 'Trạng thái thẩm định',
                dataType: 'Label',
                class: 'center',
                options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
            },
            warranty_status: { 
                name: 'warranty_status', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label',
                class: 'center',
                options: [{ value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, { value: 6, label: 'Sản phẩm huỷ'}]
                // computed: (data) => {
                //     data.warranty_status = (data.warranty_status == 5) ? 0 : data.warranty_status;
                // }
            },
            user_id: {
                refs: 'users {full_name organization_account { organization { name } } }',
                display: false
            }
        },)
    }

}